import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';
import { getToken, removeToken } from '@/utils/auth';
import router from '@/router';

const service = axios.create({
  baseURL: '/api',
  timeout: 5000
});

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers.common['token'] = getToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    Message({
      message: error.response.data.message,
      type: 'error',
      duration: 5 * 1000
    });
    if (error.response.status == 401) {
      removeToken();
      return router.replace({ path: '/login' });
    } else {
      return Promise.reject(error);
    }
  }
);

export default service;
